import React from 'react';
import Login from '@/pages/Login';

const LoginLayout: React.FunctionComponent<React.PropsWithChildren> = () => <Login />;

export default LoginLayout;
